import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BASIC_CLIENT_INFO } from '@constants/data-service.constant';
import { ERROR_CLIENTE_AUN_SIN_PAGO, GENERIC_ERROR } from "@constants/informacion-pagos-pension.constants";
import { BENEFICIARIES, DATA_UPDATE, HOME_URL, INICIO, PROFILE, ROUTING_CAMBIO_VIA_PAGO_PENSION, ROUTING_TRAMITE_PENSION, VIDEO_ATENCION } from '@constants/url.constant';
import { IPagoPension } from "@interfaces/pagos-pension.interface";
import { ViewWillEnter, ViewWillLeave } from '@ionic/angular';
import { StorageService } from '@services/storage/storage.service';
import { Util } from '@shared/common/utils/util';
import { GenericErrorOps } from "@shared/components/generic-error/interfaces/generic-error-ops.interface";
import { saveAs } from 'file-saver';
import { PagoPensionService } from "../../core/services/pago-pension.service";

@Component({
  selector: 'app-informacion-pago-pension-home',
  templateUrl: './informacion-pago-pension-home.component.html',
  styleUrls: ['./informacion-pago-pension-home.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class InformacionPagoPensionHomeComponent implements ViewWillEnter, ViewWillLeave, OnInit {

  calendario: any[] = [];
  loadingHome: boolean = false;
  showInfoPago: boolean = true;
  showComprobantePago: boolean = false;
  token: string = "";
  pagoPension: IPagoPension;
  servsError: boolean = false;
  emailOfuscado: string;
  messageList: any = [];
  runSendEmail: boolean = false;
  runDownload: boolean = false;

  dateRange = [
    { value: 'Selecciona una opción', period: 0 },
    { value: 'Último comprobante', period: 1 },
    { value: '2 últimos comprobantes', period: 2 },
    { value: '3 últimos comprobantes', period: 3 },
    { value: '6 últimos comprobantes', period: 6 },
    { value: '12 últimos comprobantes', period: 12 },
  ];
  dateRangeSelected = 0;

  errorOps: GenericErrorOps;
  attempt: boolean = false;
  nAttempts: number = 0;
  private lanzaEncuesta: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly pagoPensionSrvs: PagoPensionService,
    private readonly storageService: StorageService,
    private readonly util: Util
  ) {

  }

  ngOnInit(): void {
    void this.initData();
  }

  private async initData() {
    try {
      this.loadingHome = true;
      this.token = await this.util.getIdToken();
      await this.loadData();
    } catch (error) {
      console.error('Error inicializando home:', error);
    }
  }

  ionViewWillEnter() {
    if (!this.servsError)
      this.levantarEncuesta();
  }

  ionViewWillLeave() {
    this.lanzaEncuesta = false;
  }
  
  async loadData() {

    let cbFailure = (error: any) => {
      if (error.status == 502) {
        this.errorOps = ERROR_CLIENTE_AUN_SIN_PAGO;
      } else {
        this.errorOps = GENERIC_ERROR;
      }
      this.loadingHome = false;
      this.servsError = true;
      this.attempt = false;
    }

    let pagosOK = (response: IPagoPension) => {
      this.pagoPension = response;
      this.loadingHome = false;
      this.attempt = false;
      this.servsError = false;
    }

    this.pagoPensionSrvs.obtenerInfoPago(this.token).subscribe({
      next: pagosOK,
      error: cbFailure
    });

    const clientInfo = await this.storageService.get(BASIC_CLIENT_INFO);
    this.emailOfuscado = this.util.getEmailMasking(clientInfo?.email ?? '');

  }

  irCambioViaPago() {
    this.router.navigate([ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_BASE,
    ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_URL,
    ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_HOME]);
  }

  goToVideoAtencion() {
    this.router.navigate(
      [`/${ROUTING_TRAMITE_PENSION.BASE_URL}/${VIDEO_ATENCION}`],
      {
        relativeTo: this.activatedRoute,
      }
    );
  }

  goToYourData() {
    this.router.navigate([DATA_UPDATE, HOME_URL, PROFILE]);
  }

  goToYourBeneficiaries() {
    this.router.navigate([DATA_UPDATE, BENEFICIARIES, HOME_URL]);
  }

  showString(value: string) {
    return value.length > 0
  }

  onDateRangeChange(event: any) {
    this.dateRangeSelected = this.dateRange.find(elem => elem.value == event)?.period || 0;
  }

  close(index: number) {
    this.messageList.splice(index, 1);
  }

  async onRetryEvent() {
    if (!this.attempt) {
      this.attempt = true;
      console.log('this.attempt - ', this.attempt);

      this.nAttempts++;
      if (this.nAttempts <= 3) {
        await this.loadData();
      } else if (this.nAttempts > 3) {
        this.onGoToEvent();
      }
    }
  }

  onGoToEvent() {
    this.router.navigate([INICIO]);
  }

  imgDownloadButton() {
    if (this.dateRangeSelected == 0) {
      return 'assets/icons/download-small-gray.svg'
    } else {
      return 'assets/icons/download-small-blue.svg'
    }
  }

  async enviarEmail() {
    this.runSendEmail = true;
    this.messageList = [];

    let cbFailure = (error: any) => {
      this.runSendEmail = false;
      this.messageList.push({
        image: '/assets/certificados/icons/info_modal.svg',
        title: 'Ocurrió un error al enviar tu comprobante',
        description: 'Por favor, inténtalo nuevamente',
        type: 'error',
      });
    }

    let comprobanteOK = (response: any) => {
      this.runSendEmail = false;
      this.messageList.push({
        image: '/assets/certificados/icons/check_modal.svg',
        title: 'Tu comprobante fue enviado con éxito',
        description: 'En unos minutos llegará a tu bandeja de entrada',
        type: 'success',
      });
    }

    this.pagoPensionSrvs.obtenerPagoCmprobante(this.dateRangeSelected, this.token, false).subscribe({
      next: comprobanteOK,
      error: cbFailure
    });
  }

  downloadPDF() {
    this.runDownload = true;
    this.messageList = [];

    let cbFailure = (error: any) => {
      this.runDownload = false;
      this.messageList.push({
        image: '/assets/certificados/icons/info_modal.svg',
        title: 'Ocurrió un error al descargar tu comprobante',
        description: 'Por favor, inténtalo nuevamente',
        type: 'error',
      });
    }

    let comprobanteOK = (response: any) => {
      this.runDownload = false;
      const blob = this.pagoPensionSrvs.base64toBlob(response.stringBase64);
      saveAs(blob, `comprobante.pdf`);
      this.messageList.push({
        image: '/assets/certificados/icons/check_modal.svg',
        title: 'Tu comprobante fue descargado con éxito',
        description: 'Revísalo en tus descargas',
        type: 'success',
      });
    }

    this.pagoPensionSrvs.obtenerPagoCmprobante(this.dateRangeSelected, this.token, true).subscribe({
      next: comprobanteOK,
      error: cbFailure
    });

  }

  onElementView(value: any, targetString: string): void {
    switch (targetString) {
      case 'infopago':
        this.showInfoPago = value;
        this.showComprobantePago = !value
        break;
      case 'comprobantepago':
        this.showInfoPago = !value;
        this.showComprobantePago = value
        break;
    }
  }

  private levantarEncuesta() {
    this.lanzaEncuesta = true;
    const idEncuesta = 'Informacion-Pago-Pensiones';
    setTimeout(() => {
      if (this.lanzaEncuesta) {
        localStorage.setItem('encuestaStorage', idEncuesta);
        const evento = new StorageEvent('storage', {
          key: 'encuestaStorage',
          oldValue: idEncuesta,
          newValue: idEncuesta,
          url: globalThis.location.href,
          storageArea: localStorage,
        });
        globalThis.dispatchEvent(evento);
        this.lanzaEncuesta = false;
      }
    }, 10000);
  }
}